var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTextControl = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.52586 4.5C1.09737 4.5 0.75 4.84231 0.75 5.26457C0.75 5.68683 1.09736 6.02915 1.52586 6.02915H22.5C22.9285 6.02915 23.25 5.68683 23.25 5.26457C23.25 4.84231 22.9285 4.5 22.5 4.5H1.52586ZM1.52586 18.204C1.09737 18.204 0.75 18.5463 0.75 18.9686C0.75 19.3909 1.09736 19.7332 1.52586 19.7332H6.18103C6.60953 19.7332 6.9569 19.3909 6.9569 18.9686C6.9569 18.5463 6.60953 18.204 6.18103 18.204H1.52586Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 12.1166C0.75 12.5388 1.09231 12.8812 1.51457 12.8812H19.7586C20.8299 12.8812 21.6983 14.3815 21.6983 15.4372C21.6983 16.4928 20.8299 18.204 19.7586 18.204H15.4914V15.4372L9.28448 18.9686L15.4914 22.5V19.7332H19.7586C21.6869 19.7332 23.25 17.3374 23.25 15.4372C23.25 13.537 21.6869 11.352 19.7586 11.352H1.51457C1.09231 11.352 0.75 11.6943 0.75 12.1166V12.1166Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTextControl);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/text-control.c2787c2440d56eacc8e803029be2bd1a.svg";